import { render } from "./PantryCameraRadioItem.vue?vue&type=template&id=30b45860&ts=true"
import script from "./PantryCameraRadioItem.vue?vue&type=script&lang=ts"
export * from "./PantryCameraRadioItem.vue?vue&type=script&lang=ts"

import "./PantryCameraRadioItem.vue?vue&type=style&index=0&id=30b45860&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__